function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  "use strict";

  try {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode(".cdx-list{margin:0;padding-left:40px;outline:none}.cdx-list__item{padding:5.5px 0 5.5px 3px;line-height:1.6em}.cdx-list--unordered{list-style:disc}.cdx-list--ordered{list-style:decimal}.cdx-list-settings{display:flex}.cdx-list-settings .cdx-settings-button{width:50%}")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();

var a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="9" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 17H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 12H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 7H4.99002"/></svg>',
    o = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="12" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.79999 14L7.79999 7.2135C7.79999 7.12872 7.7011 7.0824 7.63597 7.13668L4.79999 9.5"/></svg>';

var d = /*#__PURE__*/function () {
  /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - tool constructor options
   * @param {ListData} params.data - previously saved data
   * @param {object} params.config - user config for Tool
   * @param {object} params.api - Editor.js API
   * @param {boolean} params.readOnly - read-only mode flag
   */
  function d(_ref) {
    var e = _ref.data,
        t = _ref.config,
        r = _ref.api,
        s = _ref.readOnly;

    _classCallCheck(this, d);

    this._elements = {
      wrapper: null
    }, this.api = r, this.readOnly = s, this.settings = [{
      name: "unordered",
      label: this.api.i18n.t("Unordered"),
      icon: a,
      default: t.defaultStyle === "unordered" || !1
    }, {
      name: "ordered",
      label: this.api.i18n.t("Ordered"),
      icon: o,
      default: t.defaultStyle === "ordered" || !0
    }], this._data = {
      style: this.settings.find(function (i) {
        return i.default === !0;
      }).name,
      items: []
    }, this.data = e;
  }
  /**
   * Returns list tag with items
   *
   * @returns {Element}
   * @public
   */


  _createClass(d, [{
    key: "render",
    value: function render() {
      var _this = this;

      return this._elements.wrapper = this.makeMainTag(this._data.style), this._data.items.length ? this._data.items.forEach(function (e) {
        _this._elements.wrapper.appendChild(_this._make("li", _this.CSS.item, {
          innerHTML: e
        }));
      }) : this._elements.wrapper.appendChild(this._make("li", this.CSS.item)), this.readOnly || this._elements.wrapper.addEventListener("keydown", function (e) {
        var t = 13,
            r = 8;

        switch (e.keyCode) {
          case t:
            _this.getOutofList(e);

            break;

          case r:
            _this.backspace(e);

            break;
        }
      }, !1), this._elements.wrapper;
    }
    /**
     * @returns {ListData}
     * @public
     */

  }, {
    key: "save",
    value: function save() {
      return this.data;
    }
    /**
     * Allow List Tool to be converted to/from other block
     *
     * @returns {{export: Function, import: Function}}
     */

  }, {
    key: "renderSettings",
    value:
    /**
     * Settings
     *
     * @public
     * @returns {Array}
     */
    function renderSettings() {
      var _this2 = this;

      return this.settings.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          isActive: _this2._data.style === e.name,
          closeOnActivate: !0,
          onActivate: function onActivate() {
            return _this2.toggleTune(e.name);
          }
        });
      });
    }
    /**
     * On paste callback that is fired from Editor
     *
     * @param {PasteEvent} event - event with pasted data
     */

  }, {
    key: "onPaste",
    value: function onPaste(e) {
      var t = e.detail.data;
      this.data = this.pasteHandler(t);
    }
    /**
     * List Tool on paste configuration
     *
     * @public
     */

  }, {
    key: "makeMainTag",
    value:
    /**
     * Creates main <ul> or <ol> tag depended on style
     *
     * @param {string} style - 'ordered' or 'unordered'
     * @returns {HTMLOListElement|HTMLUListElement}
     */
    function makeMainTag(e) {
      var t = e === "ordered" ? this.CSS.wrapperOrdered : this.CSS.wrapperUnordered,
          r = e === "ordered" ? "ol" : "ul";
      return this._make(r, [this.CSS.baseBlock, this.CSS.wrapper, t], {
        contentEditable: !this.readOnly
      });
    }
    /**
     * Toggles List style
     *
     * @param {string} style - 'ordered'|'unordered'
     */

  }, {
    key: "toggleTune",
    value: function toggleTune(e) {
      var t = this.makeMainTag(e);

      for (; this._elements.wrapper.hasChildNodes();) {
        t.appendChild(this._elements.wrapper.firstChild);
      }

      this._elements.wrapper.replaceWith(t), this._elements.wrapper = t, this._data.style = e;
    }
    /**
     * Styles
     *
     * @private
     */

  }, {
    key: "CSS",
    get: function get() {
      return {
        baseBlock: this.api.styles.block,
        wrapper: "cdx-list",
        wrapperOrdered: "cdx-list--ordered",
        wrapperUnordered: "cdx-list--unordered",
        item: "cdx-list__item"
      };
    }
    /**
     * List data setter
     *
     * @param {ListData} listData
     */

  }, {
    key: "data",
    get:
    /**
     * Return List data
     *
     * @returns {ListData}
     */
    function get() {
      this._data.items = [];

      var e = this._elements.wrapper.querySelectorAll(".".concat(this.CSS.item));

      for (var t = 0; t < e.length; t++) {
        e[t].innerHTML.replace("<br>", " ").trim() && this._data.items.push(e[t].innerHTML);
      }

      return this._data;
    }
    /**
     * Helper for making Elements with attributes
     *
     * @param  {string} tagName           - new Element tag name
     * @param  {Array|string} classNames  - list or name of CSS classname(s)
     * @param  {object} attributes        - any attributes
     * @returns {Element}
     */
    ,
    set: function set(e) {
      e || (e = {}), this._data.style = e.style || this.settings.find(function (r) {
        return r.default === !0;
      }).name, this._data.items = e.items || [];
      var t = this._elements.wrapper;
      t && t.parentNode.replaceChild(this.render(), t);
    }
  }, {
    key: "_make",
    value: function _make(e) {
      var _s$classList;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var s = document.createElement(e);
      Array.isArray(t) ? (_s$classList = s.classList).add.apply(_s$classList, _toConsumableArray(t)) : t && s.classList.add(t);

      for (var i in r) {
        s[i] = r[i];
      }

      return s;
    }
    /**
     * Returns current List item by the caret position
     *
     * @returns {Element}
     */

  }, {
    key: "currentItem",
    get: function get() {
      var e = window.getSelection().anchorNode;
      return e.nodeType !== Node.ELEMENT_NODE && (e = e.parentNode), e.closest(".".concat(this.CSS.item));
    }
    /**
     * Get out from List Tool
     * by Enter on the empty last item
     *
     * @param {KeyboardEvent} event
     */

  }, {
    key: "getOutofList",
    value: function getOutofList(e) {
      var t = this._elements.wrapper.querySelectorAll("." + this.CSS.item);

      if (t.length < 2) return;
      var r = t[t.length - 1],
          s = this.currentItem;
      s === r && !r.textContent.trim().length && (s.parentElement.removeChild(s), this.api.blocks.insert(), this.api.caret.setToBlock(this.api.blocks.getCurrentBlockIndex()), e.preventDefault(), e.stopPropagation());
    }
    /**
     * Handle backspace
     *
     * @param {KeyboardEvent} event
     */

  }, {
    key: "backspace",
    value: function backspace(e) {
      var t = this._elements.wrapper.querySelectorAll("." + this.CSS.item),
          r = t[0];

      r && t.length < 2 && !r.innerHTML.replace("<br>", " ").trim() && e.preventDefault();
    }
    /**
     * Select LI content by CMD+A
     *
     * @param {KeyboardEvent} event
     */

  }, {
    key: "selectItem",
    value: function selectItem(e) {
      e.preventDefault();
      var t = window.getSelection(),
          r = t.anchorNode.parentNode,
          s = r.closest("." + this.CSS.item),
          i = new Range();
      i.selectNodeContents(s), t.removeAllRanges(), t.addRange(i);
    }
    /**
     * Handle UL, OL and LI tags paste and returns List data
     *
     * @param {HTMLUListElement|HTMLOListElement|HTMLLIElement} element
     * @returns {ListData}
     */

  }, {
    key: "pasteHandler",
    value: function pasteHandler(e) {
      var t = e.tagName;
      var r;

      switch (t) {
        case "OL":
          r = "ordered";
          break;

        case "UL":
        case "LI":
          r = "unordered";
      }

      var s = {
        style: r,
        items: []
      };
      if (t === "LI") s.items = [e.innerHTML];else {
        var i = Array.from(e.querySelectorAll("LI"));
        s.items = i.map(function (n) {
          return n.innerHTML;
        }).filter(function (n) {
          return !!n.trim();
        });
      }
      return s;
    }
  }], [{
    key: "isReadOnlySupported",
    get:
    /**
     * Notify core that read-only mode is supported
     *
     * @returns {boolean}
     */
    function get() {
      return !0;
    }
    /**
     * Allow to use native Enter behaviour
     *
     * @returns {boolean}
     * @public
     */

  }, {
    key: "enableLineBreaks",
    get: function get() {
      return !0;
    }
    /**
     * Get Tool toolbox settings
     * icon - Tool icon's SVG
     * title - title to show in toolbox
     *
     * @returns {{icon: string, title: string}}
     */

  }, {
    key: "toolbox",
    get: function get() {
      return {
        icon: a,
        title: "List"
      };
    }
  }, {
    key: "conversionConfig",
    get: function get() {
      return {
        /**
         * To create exported string from list, concatenate items by dot-symbol.
         *
         * @param {ListData} data - list data to create a string from thats
         * @returns {string}
         */
        export: function _export(e) {
          return e.items.join(". ");
        },

        /**
         * To create a list from other block's string, just put it at the first item
         *
         * @param {string} string - string to create list tool data from that
         * @returns {ListData}
         */
        import: function _import(e) {
          return {
            items: [e],
            style: "unordered"
          };
        }
      };
    }
    /**
     * Sanitizer rules
     *
     * @returns {object}
     */

  }, {
    key: "sanitize",
    get: function get() {
      return {
        style: {},
        items: {
          br: !0
        }
      };
    }
  }, {
    key: "pasteConfig",
    get: function get() {
      return {
        tags: ["OL", "UL", "LI"]
      };
    }
  }]);

  return d;
}();

export { d as default };